import AuthService from '../services/services';

class AuthModel {
    constructor() {
        this.session = {};
        this.authToken = '';
        this.ttl = 0;
        this.reauthToken = '';
        this.tokenSet = false;
        this.tokenSet = true;
    }

    get(property) {
        return this[property];
    }

    getSession() {
        return AuthService.getSession();
    }

    getReauthToken(params) {
        console.log('getReauthToken()');
        return AuthService.forceReauth(params);
    }

    /**
     * *one* flow - Session comes in as some object that looks like:
     * {
     *   data: tokenSession,
     *   status: 200
     * }
     *
     * *another flow* - session is actually the real session object...
     * This flow is essentially ignored because it's the same saved token
     * @param session
     * @returns {Promise.<T>}
     */
    saveSession(session) {
        console.log('AuthModel.saveAuthToken()');

        if(session.status == 200 && typeof session.data.tokenSet === 'undefined') {
            this.session = session.data.session;
            this.authToken = this.session.authToken;
            this.tokenSet = true;
        }

        return Promise.resolve(session);
    }

    /**
     * Session comes in as some object that looks like:
     * {
     *   data: tokenSession,
     *   status: 200
     * }
     * */
    saveReauthToken(session) {
        if(session.status == 200 && typeof session.data.tokenSet === 'undefined') {
            this.session = session.data.session;
            this.reauthToken = this.session.reauthToken;
            this.tokenSet = true;
        }
        else{
            console.log('reauth token is already set');
        }

        return new Promise(function(resolve, reject){
            resolve(session);
        });
    }
}

let Auth = new AuthModel();

export default Auth;
